"use client";

import { Product } from "../../components/item/product";
import { ProductSlim } from "~/use-cases/contracts/Product";
import { useEffect, useState } from "react";

export const FilteredProducts: React.FC<{
  initialProducts: ProductSlim[];
  getProducts?: (limit: number) => Promise<ProductSlim[]>;
}> = ({ getProducts, initialProducts }) => {
  const [products, setProducts] = useState<ProductSlim[]>(initialProducts);
  useEffect(() => {
    (async () => {
      if (!getProducts) return;
      // postpone execution in js thread
      setTimeout(async () => {
        const products = await getProducts(Infinity);
        setProducts(products);
      }, 0);
    })();
  }, []);
  return (
    <div className="mt-10 mb-20">
      <div className="flex justify-between items-center">
        {products?.length < 1 && ( // Only shop when 0 results
          <h2 className="font-medium text-md my-5 text-center w-full">
            Fant {products?.length} samsvarende resultat
          </h2>
        )}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-6 gap-y-8 md:gap-y-16">
        {products.map((product, index) => (
          <Product key={index} item={product} priority={index === 0} />
        ))}
      </div>
    </div>
  );
};
